import Main from '@/pages/Main.vue';
import SearchLesson from '@/pages/SearchLesson.vue';
import MainPanel from '@/pages/MainPanel.vue';
import Chat from '@/pages/Chat.vue';

// Popups
import NotificationPopup from '@/components/NotificationPopup.vue';
import Feedback from '@/pages/Feedback.vue';
import ChatBot from '@/pages/ChatBot.vue';
import Balance from '@/pages/Balance.vue';
import Profile from '@/pages/Profile.vue';
import ProfileSettings from '@/pages/ProfileSettings.vue';
import PopupBooking from '@/pages/PopupBooking.vue';
import PopupTeam from '@/pages/PopupTeam.vue';
import PopupPaymentHistory from '@/pages/PopupPaymentHistory.vue';
import PopupMediaPermissions from '@/pages/PopupMediaPermissions.vue';
import LessonHistoryView from '@/pages/LessonHistoryView.vue';

var routes = [
  {
    path: '/',
    component: Main
  },

  {
    path: '/search-lesson',
    component: SearchLesson
  },

  {
    path: '/main-panel',
    component: MainPanel
  },

  {
    path: '/chat',
    component: Chat
  },

  {
    path: '/notification-popup',
    popup: {
      component: NotificationPopup
    }
  },

  {
    path: '/feedback',
    popup: {
      component: Feedback
    }
  },

  {
    path: '/chat-bot',
    popup: {
      component: ChatBot
    }
  },

  {
    path: '/lesson-history/:id',
    popup: {
      component: LessonHistoryView
    }
  },

  {
    path: '/balance',
    popup: {
      component: Balance
    }
  },

  {
    path: '/profile',
    popup: {
      component: Profile
    }
  },
  {
    path: '/booking',
    popup: {
      component: PopupBooking
    }
  },
  {
    path: '/team',
    popup: {
      component: PopupTeam
    }
  },
  {
    path: '/team-payment-history',
    popup: {
      component: PopupPaymentHistory
    }
  },
  {
    path: '/media-permissions',
    popup: {
      component: PopupMediaPermissions
    }
  },

  {
    path: '/profile-settings',
    component: ProfileSettings
  }
  // {
  //   path: '/request-and-load/user/:userId/',
  //   async: function (routeTo, routeFrom, resolve, reject) {
  //     // Router instance
  //     var router = this;

  //     // App instance
  //     var app = router.app;

  //     // Show Preloader
  //     app.preloader.show();

  //     // User ID from request
  //     var userId = routeTo.params.userId;

  //     // Simulate Ajax Request
  //     setTimeout(function () {
  //       // We got user data from request
  //       var user = {
  //         firstName: 'Vladimir',
  //         lastName: 'Kharlampidi',
  //         about: 'Hello, i am creator of Framework7! Hope you like it!',
  //         links: [
  //           {
  //             title: 'Framework7 Website',
  //             url: 'http://framework7.io',
  //           },
  //           {
  //             title: 'Framework7 Forum',
  //             url: 'http://forum.framework7.io',
  //           },
  //         ]
  //       };
  //       // Hide Preloader
  //       app.preloader.hide();

  //       // Resolve route to load page
  //       resolve(
  //         {
  //           component: RequestAndLoad,
  //         },
  //         {
  //           context: {
  //             user: user,
  //           }
  //         }
  //       );
  //     }, 1000);
  //   },
  // },
];

export default routes;
